const trimErrMsg = (msg) => msg.toString().replace(/Error: /i, '');

export default trimErrMsg;
